import { createRouter, createWebHashHistory } from "vue-router"
import ContentRoot from "./ContentRoot.vue"
import "./class-component-hooks"

import { routes as routesDataSharing } from "@DataSharing/routes"
import { routes as routesAlternatives } from "@Alternatives/routes"
import { routes as integrationsRoutes } from "@Integrations/routes"
import { routes as organizationsRoutes } from "@Organizations/routes"
import { routes as questRoutes } from "@Quest/routes"
import { routes as scalesRoutes } from "@Scales/routes"
import { routes as criteriaRoutes } from "@Criteria/routes"
import { routes as pagesRoutes } from "@Pages/routes"
import { routes as reportsRoutes } from "@Reports/routes"
import { routes as projectsRoutes } from "@Projects/routes"
import { routes as projectUsersRoutes } from "@ProjectUsers/routes"
import { routes as evaluationRoutes } from "@Evaluation/routes"

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        ...routesDataSharing,
        ...routesAlternatives,
        ...integrationsRoutes,
        ...organizationsRoutes,
        ...questRoutes,
        ...scalesRoutes,
        ...criteriaRoutes,
        ...pagesRoutes,
        ...reportsRoutes,
        ...projectsRoutes,
        ...projectUsersRoutes,
        ...evaluationRoutes,
        {
            path: "/:pathMatch(.*)*",
            component: ContentRoot
        }
    ] as any
})

export default router
